import script from "./HeroBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./HeroBanner.vue?vue&type=script&setup=true&lang=js"

import "./HeroBanner.vue?vue&type=style&index=0&id=0f532bdb&scoped=true&lang=css"

import exportComponent from "/home/forge/princes-trust.ac.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f532bdb"]])

export default __exports__